// extracted by mini-css-extract-plugin
export default {"item":"ParseResultItem-item-fq1V3","title":"ParseResultItem-title-Jvbx7"};